import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { useMediaQuery } from 'react-responsive';
const color = { react: '#61dbfb', js: '#f0db4f', aws: '#000', python: '#6281b6' };
const blogArticles = [
	{
		title: 'APIから取得したデータから折れ線グラフを作成する',
		img: 'https://anzunba.com/wp-content/uploads/2020/07/chartjs2.jpg',
		url: 'https://anzunba.com/2020/07/23/chartjs/',
		color: color['react']
	},
	{
		title: 'React Hooks チートシート',
		img: 'https://anzunba.com/wp-content/uploads/2020/07/React.png',
		url: 'https://anzunba.com/2020/07/24/react-hooks/',
		color: color['react']
	},
	{
		title: 'ReactでJQueryを使うことについて。',
		img: 'https://anzunba.com/wp-content/uploads/2020/07/jquery.png',
		url: 'https://anzunba.com/2020/07/24/jquery/',
		color: color['react']
	},
	{
		title: 'JavaScriptのコールバック関数',
		img: 'https://anzunba.com/wp-content/uploads/2020/07/javascript.png',
		url: 'https://anzunba.com/2020/07/24/callback/',
		color: color['js']
	},
	{
		title: 'Amazon EKSを使ってみました',
		img: 'https://www.beex-inc.com/blog/wp-content/uploads/2019/08/eks_logo-1.png',
		url: 'https://www.beex-inc.com/blog/try-eks/',
		color: color['aws']
	},
	{
		title: 'API GatewayとLambdaでSlack翻訳アプリを作成してみました',
		img: 'https://www.beex-inc.com/blog/wp-content/uploads/2019/08/026.png',
		url: 'https://www.beex-inc.com/blog/translate-slack-app/',
		color: color['aws']
	},
	{
		title: '自然言語処理（NLP）とは？具体例と８つの課題＆解決策',
		img: 'https://spjai.com/wp-content/uploads/2017/09/nlp2.png',
		url: 'https://spjai.com/nlp/',
		color: color['python']
	},
	{
		title: 'ニューラルネットワークについて',
		img: 'https://image.slidesharecdn.com/random-171004013257/95/-2-1024.jpg?cb=1507084861',
		url: 'https://www.slideshare.net/AnnaNakatsuji/ss-80433621',
		color: color['python']
	}
];
const count = 4 - blogArticles.length % 4;
let i = 0;
while (i < count) {
	blogArticles.push('');
	i += 1;
}
let devidedArticles = [];
const split = (array, n) =>
	array.reduce((a, c, i) => (i % n == 0 ? [ ...a, [ c ] ] : [ ...a.slice(0, -1), [ ...a[a.length - 1], c ] ]), []);
devidedArticles = split(blogArticles, 4);
const sectionTitle = { en: 'Blog', ja: 'ブログ' };
const BlogCard = ({ language }) => {
	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
	return (
		<div>
			<h1 className="text-center sectionTitle mb-5" style={{paddingTop:'10rem'}}>
				{language == 'English' ? sectionTitle.en : sectionTitle.ja}
			</h1>
			{devidedArticles.map((fourArticles, i) => {
				return (
					<Grid container spacing={2} key={i}>
						{fourArticles.map((article, j) => {
							return article ? (
								<Grid item md={3} sm={6} xm={12} key={j} className={`d-flex justify-content-center ${isTabletOrMobile?'w-100': null}`}>
									<Card
										style={{
											borderTop: `3px solid ${article.color}`,
											width: '100%',
											minWidth: '200px'
										}}
									>
										<CardHeader title={article.title} style={{ height: '50px' }} />
										<CardMedia
											image={article.img}
											style={{ height: '170px', backgroundSize: 'contain' }}
										/>
										<CardActions disableSpacing>
											<Button target="_blank" href={article.url} fullWidth color="secondary">
												Read
											</Button>
										</CardActions>
									</Card>
								</Grid>
							) : null;
						})}
					</Grid>
				);
			})};
		</div>
	);
};
export default BlogCard;
